export enum FeatureToggle {
  onboarding = 'onboarding',
  launchOnboarding = 'rt_partner_onboarding',
  PartnerOnboardingSignupInProgressRedirect = 'partner_onboarding_signup_in_progress_redirect',
  OnboardingSiteSetupChecklist = 'rt_sfp_onboarding_dashboard_checklist',
  PresignedS3FileUploads = 'rt_presigned_s3_file_uploads',
}
